// extracted by mini-css-extract-plugin
export default {"dialog":"gXn7weeXCGN9zdu1hBTg","titleBar":"Eu8QxuLqLLjrk_RcU4Se","content":"b8PNaXzzaPFuS9d_vmXd"};